import React, { forwardRef, ReactElement } from 'react';

import { useAutoProgress } from 'src/application/features/RestrictNavigation/hooks/useAutoProgress';

import {
  CloseNavigationButton,
  NextNavigationButton,
  PreviousNavigationButton,
} from '../../../../components/NavigationButtons';
import { StudentNavigationBar } from '@ael/shared-components-library';

interface NavigationProps {
  goToNext?: () => void;
  goToPrevious?: () => void;
  close?: () => void;
  progressDisabled: boolean;
  autoProgress?: boolean;
  audioPlayer?: ReactElement;
}

export const Navigation = forwardRef(
  (
    { goToNext, goToPrevious, close, progressDisabled, autoProgress, audioPlayer }: NavigationProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const hasMultipleItems = Boolean(goToPrevious) || Boolean(goToNext);

    const { autoProgressStarted } = useAutoProgress({ autoProgress, onProgress: () => goToNext?.() });

    return (
      <StudentNavigationBar
        ref={ref}
        type="StudentFull"
        goToNext={goToNext}
        goToPrevious={goToPrevious}
        autoProgressStarted={autoProgressStarted}
        progressDisabled={progressDisabled}
      >
        {audioPlayer && <StudentNavigationBar.ButtonBox>{audioPlayer}</StudentNavigationBar.ButtonBox>}
        <StudentNavigationBar.ButtonBox justifyEnd>
          {hasMultipleItems && (
            <>
              <PreviousNavigationButton disabled={!goToPrevious} onClick={goToPrevious} />
              <NextNavigationButton disabled={progressDisabled || !goToNext} onClick={goToNext} />
            </>
          )}
          {close && <CloseNavigationButton onClick={close} big />}
        </StudentNavigationBar.ButtonBox>
      </StudentNavigationBar>
    );
  }
);
